<template>
  <div class="content">
    <div>
      <div class="con-tit">{{ title }}</div>
      <div class="con-sum" v-html="digest"></div>
    </div>
    <!-- <div>
      <img class="img-sty" style="100%" :src="img" alt="" />
    </div> -->
    <div class="html-sty" v-html="content"></div>
    <div class="but">
      <van-button round color="#FC6E09" @click.prevent="onConsult">咨询</van-button>
    </div>
    <Consult ref="progressTwo" :id="id"></Consult>
  </div>
</template>
<script>
import URL from "@/api/api";
import Consult from "./consult.vue";
import {Toast} from "vant";

export default {
  components: {Consult},
  data() {
    return {
      id: this.$route.query.id,
      agentUserId: this.$route.query.agentUserId,
      digest: "",
      title: "",
      content: "",
      // img: "",
      externalLink: "",
    };
  },
  mounted() {
    this.fatchdata();
  },
  methods: {
    fatchdata() {
      this.$fetchGet(URL.productDetails.url, {id: this.id}).then((res) => {
        (this.title = res.data.data.name), (this.digest = res.data.data.digest);
        this.content = res.data.data.content;
        // this.img = res.data.data.img;
        this.externalLink = res.data.data.externalLink;
      });
    },
    onConsult() {
      if ('车险' === this.title) {
        this.$fetchPost(URL.judgeWhetherSub.url, this.$toFormData({'openid': localStorage.getItem("openid")})).then(res => {
          if (res.data.code != 20000) {
            Toast(res.data.msg);
          } else {
            this.$router.push({path: '/quoteInfo', query: {agentUserId: this.agentUserId}});
          }
        })
      } else {
        this.$refs.progressTwo.show = true;
      }
    },
    judgeSub() {

    }
  },
};
</script>
<style scoped>
.content {
  margin: 10px auto;
  padding: 0 15px;
  background: #fff;
  /* border: 1px solid; */
}

.con-tit {
  font-size: 25px;
  text-align: center;
}

.con-sum {
  font-size: 20px;
  text-align: left;
  margin: 22px 0;
}

.html-sty {
  font-size: 16px;
}

.html-sty >>> img {
  width: 100%;
}

.but {
  width: 335px;
  margin: auto;
  padding-bottom: 20px;
}

.van-button {
  width: 100%;
}

.img-sty {
  width: 100%;
}
</style>
